// import {User} from "@/classes/User";
// import { reactive } from 'vue'
//
// export default reactive({
//   loggedInUser: new User(),
//   appointments:[],
//   users:[],
//   jobs:[],
// });


import {createStore} from "vuex";
//import {User} from "@/classes/User"

const state = {
  appointments:[],
  loggedInUser: null,
  users:[],
  jobs: [],
};

const getters = {
  hasAdmin(){
    let idx = state.users.findIndex(elem =>{return elem.isAdmin ===true})
    return idx > -1;
  },
  AppointmentLength(){
    return state.appointments.length;
  },
  NoUsers(){
    return state.users.length ===0 || (state.users.length ===1 && state.users[0].fName === "admin");
  },
  NoJobs(){
    console.log("jobs")
    console.log(state.jobs.length)
    return state.jobs.length ===0;
  },
  // setLoggedInUser(state, loggedInUser) {
  //   state.loggedInUser = loggedInUser
  // },
  FirstThing(){
    //console.log("users length: "+ state.users.length);
    //
    let isFirstThing = state.users.length ===0 || (state.users.length >=1 && state.users[0].fName === "admin") ;
    if(state.users.length > 1 && state.users[0].fName === "admin"){
      // remove the admin users
      let idx = state.users.findIndex(elem => {return elem.fName === state.users[0].fName })
      if(idx > -1) {
        state.users.splice(idx, 1);
      }
    }
    return isFirstThing;
  }

};

const mutations ={
  setRota(state,appts){
    state.appointments = appts;
  },
  setUsers(state,users){
    state.users = users;
  },
  setJobs(state,jobs){
    state.jobs = jobs;
  },
  addAppointment(state,appt){
    //console.log("Commit addAppointment")
    state.appointments.push(appt);
  },
  addUser(state,user){
    state.users.push(user);
  },
  addJob(state,job){
    state.jobs.push(job);
    //console.log(state.jobs.length)
    //this.NoJobs()
  },
  editUser(state, user){
    let idx = state.users.findIndex(elem =>{return elem.id === user.id});
    if(idx > -1) {
      state.users.splice(idx, 1, user);
    }
  },
  editAppointment(state,appt){
    let idx = state.appointments.findIndex(elem =>{return elem.id === appt.id});
    if(idx > -1) {
      state.appointments.splice(idx, 1, appt);
    }
  },
  editJob(state,job){
    let idx = state.jobs.findIndex(elem =>{return elem.id === job.id});
    if(idx >-1) {
      state.jobs.splice(idx, 1, job);
    }
  },
  deleteAppointment(state,appt){
    let idx = state.appointments.findIndex(elem =>{return elem.id === appt.id});
    if(idx > -1) {
      state.appointments.splice(idx, 1);
    }
  },
  deleteJob(state,job){
    let idx = state.jobs.findIndex(elem => {
      return elem.id === job.id
    });
    if (idx > -1) {
      state.jobs.splice(idx, 1);
    }
  },
  deleteUser(state, user) {
    let idx = state.users.findIndex(elem => {
      return elem.id === user.id
    });
    if (idx > -1) {
      state.users.splice(idx, 1);
    }
  },
  setLoggedInUser(state, loggedInUser) {

    setTimeout(() => {
      state.loggedInUser = null;
    }, 500);
  },

};

const store = createStore({
  state: state,
  getters: getters,
  mutations: mutations,
})
export default store;
